import { useEffect, useState } from 'react';
import { appearance as appearanceSelector } from 'src/redux/basic.slice';
import { useAppSelector } from 'src/redux/hooks';

// Live "now" for the Track header clock, which displays seconds — so this ticks
// every second, aligned to the wall-clock second boundary so the digit flips when
// the real second flips rather than drifting up to 999ms behind it.
//
// Ported from wal-frontend-v2 src/app/Radar/hooks/useRadarClock.ts. Like WAL, the
// zone comes from `appearance.timezone` in the basic slice — the same field the
// rest of the Track page reads (index.tsx, TrackLeftSidebar, status strips). In
// the portal that field is the resolved READER's clock (see basic.slice.tsx /
// utils/viewerTimezone.ts), and because it is a Redux selector the clock
// re-renders the moment appearance is loaded or changed.
//
// NOTE: the map's per-timezone overlay labels do NOT use this hook. They only show
// hours and minutes and tick on their own minute timer inside TrackMapLayout.
export const useTrackClock = () => {
    const appearance = useAppSelector(appearanceSelector);
    const timezone: string | undefined = appearance?.timezone;

    const [now, setNow] = useState<Date>(() => new Date());

    useEffect(() => {
        let intervalId: ReturnType<typeof setInterval> | undefined;

        const msToNextSecond = 1000 - (Date.now() % 1000);

        const alignTimeoutId = setTimeout(() => {
            setNow(new Date());
            intervalId = setInterval(() => setNow(new Date()), 1000);
        }, msToNextSecond);

        return () => {
            clearTimeout(alignTimeoutId);

            if (intervalId) clearInterval(intervalId);
        };
    }, []);

    return { now, timezone };
};

export default useTrackClock;
